import OriginTracing from '@atlassiansox/origin-tracing';

export const addAtlOriginToUrl = (url: string): string => {
	if (!url) {
		return '';
	}
	const origin = new OriginTracing({ product: 'confluence' });
	return origin.addToUrl(url);
};
